import RecordStore from 'stores/record/RecordStore'

import createError from 'utils/createError'
import stringify from 'utils/stringify'

const getFindOneQuery = (recordId: string) => {
  const record = RecordStore.get(recordId)
  if (!record) {
    throw createError('getFindOneQuery', 'Invalid recordId', {
      recordId,
    })
  }

  const model = record.model
  const uniqueIdentifiers = model.uniqueIdentifiers

  // The `where` argument should be something that identifies the record uniquely
  const whereArgumentName = uniqueIdentifiers.map(f => f.name).join('_') // like id_name etc. (needed for compound IDs)
  const whereArgumentValue = uniqueIdentifiers
    .map(f => `${f.name}: ${stringify(record.value[f.name])}`)
    .join(', ')

  let whereArgument
  if (uniqueIdentifiers.length === 1) {
    // For models with simple IDs / uniques (can be `where: { id: 0 }`)
    whereArgument = `{ ${whereArgumentValue} }`
  } else {
    // For models with compound IDs / uniques (needs to be `where: { id_name: { id: 0. name: "xx" }`)
    whereArgument = `{ ${whereArgumentName}: { ${whereArgumentValue} } }`
  }

  return [
    `prisma.${model.photonNamespace}.findUnique({`,
    `  where: ${whereArgument},`,
    `  select: {`,
    `    ${model.fields.map(f => `${f.name}: true`).join(',\n    ')}`,
    `  }`,
    `})`,
  ].join('\n')
}

export default getFindOneQuery
